import trimUnits from '../utils/trimUnits'

class Theme {
  constructor() {
    this.colorPrimary = '#30576e'
    this.colorBackground = '#edf0f2'

    this.themeColorPrimary = '#30576E'
    this.themeColorPrimaryOpacity = 'rgba(54,98,112, 0.8)'
    this.themeColorSecondary = '#EDF0F2'
    this.themeColorAccent = '#60EAAD'
    this.themeColorPrimaryDarkend = '#4BCF95'
    this.themeColorWhite = '#FFFFFF'
    this.themeColorWhiteDarkend = '#EDF0F2'
    this.themeColorLight = '#F9F9F9'
    this.themeColorPale = '#A7B5BC'
    this.themeColorPaleOpacity = 'rgba(167, 181, 188, 0.4)'
    this.themeColorError = '#f46077'

    this.gutter = '1rem'
    this.gutterSmall = `${trimUnits(this.gutter) / 2}rem`
    this.gutterMedium = `${trimUnits(this.gutter) * 2}rem`
    this.gutterLarge = `${trimUnits(this.gutter) * 4}rem`

    this.fontFamilyPrimary = '\'Roboto\', \'Arial\', sans-serif'

    this.fontSizeRoot = '20px'
    this.fontSizeMobile = '16px'
    this.fontSizeSmall = '0.9em'
    this.fontSizeH1 = '2em' // 60px at max-width and up
    this.fontSizeH2 = '1.5em'
    this.fontSizeH3 = '1.4em'
    this.fontSizeH4 = '1.1em'
    this.fontSizeResponsive = 'calc(14px + 0.41vw)'

    this.lineHeightRegular = '1.45em'
    this.lineHeightH1 = '1.1em'
    this.lineHeightH2 = '1.1em'
    this.lineHeightH3 = '1.1em'
    this.lineHeightH4 = '1.1em'

    this.borderRadius = '8px'
  }
}

export default Theme